import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

export function getCreditRatingPage(data) {
    return request({
        url: `/${systemConfig.employmentPrefix}/institutionCreditRatingInfo/gl/v1.0.0/page`,
        method: 'post',
        data
    })
}

export function addCreditRating(data) {
    return request({
        url: `/${systemConfig.employmentPrefix}/institutionCreditRatingInfo/gl/v1.0.0/add`,
        method: 'post',
        data
    })
}

export function updateCreditRating(data) {
    return request({
        url: `/${systemConfig.employmentPrefix}/institutionCreditRatingInfo/gl/v1.0.0/update`,
        method: 'post',
        data
    })
}

export function deleteCreditRating(id) {
    return request({
        url: `/${systemConfig.employmentPrefix}/institutionCreditRatingInfo/gl/v1.0.0/delete`,
        method: 'post',
        data: {
            id: id
        }
    })
}

export function downloadCreditRatingTemplate() {
    return request({
        url: `/${systemConfig.employmentPrefix}/institutionCreditRatingInfo/gl/v1.0.0/excelTemplateGain`,
        method: 'post',
        responseType: 'blob'
    })
}

export function importCreditRating(data) {
    return request({
        url: `/${systemConfig.employmentPrefix}/institutionCreditRatingInfo/gl/v1.0.0/institutionCreditRatingImport`,
        method: 'post',
        data
    })
}
